import React from 'react';

export function BrElement() {
  return <br />;
}
